import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { hexToRGBA } from '../../lib/colors';
import ThemeContext from '../../theme/ThemeContext';

import Icon from './Icon';

export const RotateKeyframeAnim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`;

const AnimatedIconContainer = styled.span`
  display: inline-block;
  animation: ${RotateKeyframeAnim} 1.2s infinite linear;
`;

const StyledButton = styled.button`
  background: ${(props) => props.theme.backgroundColor};
  border: 1px solid
    ${(props) => (props.selected ? props.theme.hoverColor : props.theme.borderColor)};
  border-radius: ${(props) => props.theme.borderRadius}px;
  color: ${(props) => (props.selected ? props.theme.hoverColor : props.theme.color)};
  font-size: 12px;
  padding: ${(props) => props.theme.padding};
  transition: all 0.15s ease-in-out;

  svg {
    color: ${(props) => (props.selected ? props.theme.hoverColor : props.theme.color)};
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    border: 1px solid ${(props) => props.theme.hoverColor};
    color: ${(props) => props.theme.hoverColor};
    svg {
      color: ${(props) => props.theme.hoverColor};
    }
  }
`;

const StyledButtonText = styled.span``;

const Button = ({
  danger,
  solid,
  size,
  icon,
  text,
  styles,
  classes,
  loading,
  disabled,
  onClick,
  selected,
}) => {

  const theme = useContext(ThemeContext);

  let color = theme.fontColorPrimary;
  let hoverColor = theme.primaryColor;
  let borderColor = theme.borderColor;

  if (danger) {
    color = theme.dangerColor;
    hoverColor = hexToRGBA(theme.dangerColor, '0.7');
    borderColor = theme.dangerColor;
  } else if (disabled) {
    color = theme.borderColor;
    hoverColor = theme.borderColor;
    borderColor = theme.borderColor;
  }

  let padding = '8px 12px';
  if (size === 'sm') padding = '4px 8px';

  let iconNode = null;
  if (icon) iconNode = <Icon id="icon" icon={icon} />;
  if (loading) { iconNode = (
    <AnimatedIconContainer>
      <Icon icon={faSpinner} extraProps={{ 'data-testid': 'loading-icon' }} />
    </AnimatedIconContainer>
  ); }

  return (
    <StyledButton
      disabled={disabled}
      className={classes}
      selected={selected}
      style={styles}
      theme={{
        backgroundColor: solid ? theme.backgroundColor : 'transparent',
        padding,
        color,
        hoverColor,
        borderColor,
        borderRadius: theme.borderRadius
      }}
      tabIndex={-1}
      onClick={disabled ? null : onClick}
    >
      {iconNode}
      {!text ? null : <StyledButtonText style={{ paddingLeft: icon ? '6px' : '' }}>{text}</StyledButtonText>}
    </StyledButton>
  );
};

Button.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  danger: PropTypes.bool,
  size: PropTypes.oneOf(['sm']),
  icon: PropTypes.any,
  text: PropTypes.string,
  styles: PropTypes.object,
  classes: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;